var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logined"},[_c('img',{attrs:{"src":_vm.avatar ? _vm.avatar : _vm.userInfo.avatar}}),_c('span',[_vm._v(_vm._s(_vm.name ? 'Hi,'+_vm.name : _vm.userInfo.username))])])}
var staticRenderFns = []

export { render, staticRenderFns }